export function getMaxOrder(list) {
  if (!Array.isArray(list) || list.length === 0) return 0;
  const orders = list
    .map((item) => item?.order)
    .filter((o) => typeof o === "number");

  return orders.length > 0 ? Math.max(...orders) : 0;
}
